import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=3a956ad9&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=3a956ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a956ad9",
  null
  
)

export default component.exports